import React from "react";
import { Box, Paper, Typography, Avatar, Stack } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { defaultGradient } from "@src/shared/const";

//Перенести стили из sx в классы

export interface RequestCardProps {
  id?: string;
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  processedNumber?: number;
  onClick?: () => void;
  gradient?: string;
  ariaLabel?: string;
}

export const RequestCard: React.FC<RequestCardProps> = ({
  title,
  subtitle,
  icon,
  processedNumber = 0,
  onClick,
  gradient = defaultGradient,
  ariaLabel,
}) => {
  return (
    <Paper
      role={onClick ? "button" : "article"}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(e) => {
        if (onClick && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onClick();
        }
      }}
      elevation={0}
      sx={{
        background: gradient,
        borderRadius: "20px",
        color: "common.white",
        p: 3,
        minWidth: 320,
        maxWidth: 550,
        height: 300,
        flex: "1 1 420px",
        position: "relative",
        overflow: "visible",
        cursor: onClick ? "pointer" : "default",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        border: "1px solid rgba(255,255,255,0.08)",
        padding: "30px 20px",
        ...(!onClick && { opacity: 0.4 }),
        "@media (max-width: 1600px)": {
          height: 260,
          padding: "24px 18px",
          "& h5": { fontSize: "26px" },
        },
        "@media (max-width: 1440px)": {
          height: 240,
          padding: "20px 16px",
          "& h5": { fontSize: "24px" },
        },
        "@media (max-width: 1280px)": {
          height: 220,
          padding: "18px 14px",
          "& h5": { fontSize: "22px" },
        },
        "@media (max-width: 1024px)": {
          flex: "1 1 100%",
          maxWidth: "100%",
          height: "auto",
          minHeight: 200,
        },
      }}
      aria-label={ariaLabel || title}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Avatar
          sx={{
            bgcolor: "transparent",
            width: 52,
            height: 52,
            border: "none",
          }}
        >
          {icon ?? (
            <PersonOutlineIcon sx={{ color: "rgba(255, 255, 255, 1)" }} />
          )}
        </Avatar>
        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: 500, lineHeight: 1.1, fontSize: "30px" }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ opacity: 0.9, mt: 0.5 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={3}
      >
        <Box>
          <Typography variant="caption" sx={{ opacity: 0.9 }}>
            Обработано запросов
          </Typography>
          <Stack direction="row" spacing={0} sx={{ mt: 2 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                bgcolor: "rgba(255,255,255,0.4)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 600,
                fontSize: 18,
              }}
            >
              {processedNumber}
            </Box>
          </Stack>
        </Box>
      </Box>
    </Paper>
  );
};
